import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'cosignerInput',
    'cosignerFieldset',
    'familySituationInput',
    'familySituationDateFieldset',
    'matrimonialRegimeFieldset'
  ]

  connect () {
    this.toggleCosignerFieldset()
    this.toggleFamilySituationFieldsets()
  }

  toggleCosignerFieldset () {
    this.cosignerFieldsetTarget.hidden = !this.cosignerInputTarget.checked
    this.cosignerFieldsetTarget.disabled = !this.cosignerInputTarget.checked
  }

  toggleFamilySituationFieldsets () {
    const familySituation = this.familySituationInputTargets.find(input => input.checked)

    if (this.hasMatrimonialRegimeFieldsetTarget) {
      const disabled = !(familySituation && familySituation.value === "married")
      this.matrimonialRegimeFieldsetTarget.hidden = disabled
      this.matrimonialRegimeFieldsetTarget.disabled = disabled
    }

    if (this.hasFamilySituationDateFieldsetTarget) {
      const disabled = !(familySituation && ["pacs", "married"].includes(familySituation.value))
      this.familySituationDateFieldsetTarget.hidden = disabled
      this.familySituationDateFieldsetTarget.disabled = disabled
    }
  }
}
